import { useCallback, useEffect, useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { ReviewForm, ReviewItem } from "@/components/ReviewParts";
import { api, errorMessage } from "@/lib/api";


export function Reviews({ item, city = "" }) {
  const [data, setData] = useState(null);
  const [rating, setRating] = useState(0);
  const [text, setText] = useState("");
  const [photos, setPhotos] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => api.get("/reviews", { params: { place_key: item.place_key } }).then((r) => {
    setData(r.data);
    const mine = r.data.reviews.find((x) => x.mine);
    if (mine) { setRating(mine.rating); setText(mine.text); setPhotos(mine.photos || []); }
  }).catch(() => {}), [item.place_key]);
  useEffect(() => { if (item.place_key) load(); }, [item.place_key, load]);

  if (!item.place_key) return null;
  const mine = data?.reviews.find((x) => x.mine);

  const submit = async () => {
    if (!rating) return toast.error("Tap a star rating first");
    setBusy(true);
    try { await api.post("/reviews", { place_key: item.place_key, place_name: item.name, rating, text, photos, city }); toast.success("Thanks for your review!"); load(); }
    catch (e) { toast.error(errorMessage(e)); }
    finally { setBusy(false); }
  };
  const remove = async (id) => {
    try { await api.delete(`/reviews/${id}`); setRating(0); setText(""); setPhotos([]); load(); } catch (e) { toast.error(errorMessage(e)); }
  };

  return (
    <div data-testid="reviews-section" className="space-y-3">
      <div className="flex items-center justify-between">
        <h4 className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Traveler reviews</h4>
        {data?.count > 0 && <span data-testid="reviews-summary" className="text-sm text-[#FFB800] flex items-center gap-1"><Star className="h-3.5 w-3.5 fill-current" />{data.avg} · {data.count} {data.count === 1 ? "review" : "reviews"}</span>}
      </div>
      <ReviewForm mine={mine} rating={rating} setRating={setRating} text={text} setText={setText} photos={photos} setPhotos={setPhotos} busy={busy} submit={submit} />
      {data?.reviews.map((r) => <ReviewItem key={r.id} r={r} remove={remove} load={load} />)}
    </div>
  );
}
